"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveForBrowser = void 0;
const ensign_1 = require("./ensign");
const providers_1 = require("./providers");
async function resolveForBrowser({ appName, environment, context, featureDefinitions, }) {
    const instance = ensign_1.Ensign.create({
        environment,
        featureDefinitions,
        providers: [new providers_1.BrowserProvider(appName)],
    });
    const promise = instance.resolve(context);
    if (typeof window === 'object') {
        // Add to global registry
        const w = window;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        w['ensign'] = w['ensign'] || {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        w['ensign'][appName] = promise;
        // Emit as event
        const event = new CustomEvent('EnsignResolved', {
            detail: {
                appName,
                resolved: promise,
            },
        });
        window.dispatchEvent(event);
    }
    return promise;
}
exports.resolveForBrowser = resolveForBrowser;
//# sourceMappingURL=resolve-for-browser.js.map